import React from 'react';
import HomeDashboard from '../common/HomeDashboard/HomeDashboard';
import usePermissions from '../../hooks/features/permissions/usePermissions';

const Home = () => {
  const {
    userContext: { isExternal },
  } = usePermissions();

  return (
    <HomeDashboard
      persona="customer"
      showReviewKpis={isExternal}
      showSlaKpis={isExternal}
      showDraftKpi={isExternal}
    />
  );
};

export default Home;
